import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { KeyFilterPattern } from 'primeng/keyfilter';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import {
  EoInputConfig,
  IEoInputConfig,
  InputIconPos,
  InputType,
} from './eo-input.model';

@Component({
  selector: 'eo-input',
  templateUrl: './eo-input.component.html',
  styleUrl: './eo-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoInputComponent),
      multi: true,
    },
  ],
})
export class EoInputComponent extends EoBaseFormControlComponent {
  protected override _config?: IEoInputConfig;
  override get config(): EoInputConfig | undefined {
    return this._config;
  }
  override set config(val: IEoInputConfig | undefined) {
    this._config = val;
  }

  @Input() type?: InputType;
  @Input() inputIcon?: string;
  @Input() inputIconPos?: InputIconPos;
  @Input() pKeyFilter?: RegExp | KeyFilterPattern | null;
  @Input() inputStyleClass?: string;
  @Input() placeholder?: string;
  @Input() numMode? : string;
  @Input() minFractionDigits? : string;

  protected getType(): string {
    return this.type ?? this.config?.type ?? 'text';
  }

  protected isHidden():boolean{
    return this.getType()=='hidden';
  }

  protected isNumber(): boolean {
    return this.getType()=='number';
  }
  
  protected notNumber(): boolean {
    return this.getType()!='number';
  }

  protected getMode(): string {
    return this.numMode?? this.config?.numMode ?? 'decimal';
  }
  protected getMinFractionDigits(): string {
    return this.minFractionDigits ?? this.config?.minFractionDigits ?? "0";
  }
  
  protected hasInputIcon(): boolean {
    return this.inputIcon != null || this.config?.inputIcon != null;
  }
  protected getInputIcon(): string | null {
    return this.inputIcon ?? this.config?.inputIcon ?? null;
  }
  protected getInputIconPos(): string {
    if (!this.getInputIcon()) return '';
    const iconPos = this.inputIconPos ?? this.config?.inputIconPos ?? 'left';
    return `p-input-icon-${iconPos}`;
  }
  protected getPlaceholder(): string {
    return this.placeholder ?? this.config?.placeholder ?? '';
  }
  protected getPKeyFilter(): RegExp | KeyFilterPattern | null {
    return this.pKeyFilter ?? this.config?.pKeyFilter ?? null;
  }
  protected getInputStyleClass(): string {
    return this.inputStyleClass ?? this.config?.inputStyleClass ?? '';
  }
}
